"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var ProgressBar = function (props) {
    var end = props.end, screenreaderText = props.screenreaderText, start = props.start, width = props.width;
    var styleWidth = function () {
        if (width <= 0) {
            return 0;
        }
        if (width < 2) {
            return 2;
        }
        return width;
    };
    return (React.createElement("div", { className: "progress-wrapper" },
        React.createElement("div", { className: "progress" },
            React.createElement("div", { role: "progressbar", className: "progress-bar", style: { width: styleWidth() + "%" }, "aria-valuetext": screenreaderText ? screenreaderText : width + " percent" + (end ? " of " + end : '') })),
        start && end &&
            React.createElement("div", { "aria-hidden": "true", className: "ruler" },
                React.createElement("span", null, start),
                React.createElement("span", null, end))));
};
exports.ProgressBar = ProgressBar;
exports.ProgressBar.defaultProps = {
    end: '',
    screenreaderText: '',
    start: '',
};
exports.ProgressBar.propTypes = {
    end: PropTypes.string,
    screenreaderText: PropTypes.string,
    start: PropTypes.string,
    width: PropTypes.number.isRequired,
};
